import { render, staticRenderFns } from "./Privacity.vue?vue&type=template&id=3292dd42&scoped=true&lang=pug&"
var script = {}
import style0 from "./Privacity.vue?vue&type=style&index=0&id=3292dd42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3292dd42",
  null
  
)

export default component.exports